var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',[_c('img',{attrs:{"src":require("../../assets/imgs/oval.svg"),"width":"50","alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }